import { Build, Env } from '@stencil/core';
import algoliasearch from 'algoliasearch';

export const mobileBannerMessage = 'Design Custom T-shirts & More';
export const desktopBannerMessage = 'Custom T-shirts & Promotional Products, Fast & Free Shipping, and All-Inclusive Pricing';
export const showSixHitsPerPage = 6;
export const showFourHitsPerPage = 4;
export const autoCompleteFacets = [
  { name: 'categories.name', caption: 'Categories', showNum: 8 },
  { name: 'manufacturer', caption: 'Brands', showNum: 8 }
];
export const algoliaPermittedNavParams = [
  'iframer',
  'compatible_style',
  'compatible_type',
  'cid',
  'digest',
  'multi_item',
  'preferred_colors',
  'keep_shopping',
  'quote_fc',
  'quote_bc',
  'min_qty[]',
];
export const searchClient = algoliasearch(Env.ALGOLIA_APPLICATION_ID, Env.ALGOLIA_SEARCH_API_KEY);
export const suggestedQueriesIndexName = Env.NODE_ENV === 'production' ? 'prod_styles_query_suggestions' : Env.NODE_ENV + '_styles_query_suggestions';
export const indexName = Env.NODE_ENV === 'production' ? 'prod_styles' : Env.NODE_ENV + '_styles';
export const isBrowser = Build.isBrowser || Build.isTesting;

export const checkoutLink = `${process.env.CI_HOSTNAME}/checkout/summary?cart_source=header`;


export const signInLink = `${process.env.CI_HOSTNAME}/profiles/users/sign_in`;
export const accountsLink = `${process.env.CI_HOSTNAME}/account`;
export const toAccountsLink = (isUserLogged: boolean) => isUserLogged ? accountsLink : signInLink;
